export * from './Dob';
export * from './NameRow';
export { ParentRow } from './ParentRow';
export { default as ParentRowConnected } from './ParentRow';
export * from './ProfileRow';
export * from './BasePlatoonRow';



// WEBPACK FOOTER //
// ./src/pages/base-managment/soldiers/components/index.js